import { forwardRef } from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { Box, SxProps, Theme } from '@mui/material';

import { Tooltip } from 'common/components/Tooltip';
import { Link } from 'common/components/Link';
import { Badge } from 'common/components/Badge';
import { IUnreadBadge } from 'graphql/types';

interface IProps extends IconButtonProps<typeof Link> {
    autoSize?: boolean;
    badge?: IUnreadBadge;
    tooltipText: string;
    /** Open indicates that the dropdown menu is open */
    open?: boolean;
}

export const NavigationItem = forwardRef<HTMLButtonElement, IProps>(
    function NavigationItem(
        {
            autoSize,
            badge,
            children,
            tooltipText,
            href,
            open,
            to,
            target,
            onClick,
            ...other
        },
        ref
    ) {
        let icon = children;

        if (badge) {
            icon = (
                <Badge badgeContent={badge.count} color="error" max={99}>
                    {icon}
                </Badge>
            );
        }

        const buttonSx: SxProps<Theme> = {
            color: (theme) => theme.vars.palette.body.main,
            width: !autoSize ? '50px' : undefined,
            height: !autoSize ? '50px' : undefined,
            padding: 0,
        };

        let button = (
            <Box>
                <IconButton
                    ref={ref}
                    size="large"
                    sx={buttonSx}
                    onClick={onClick}
                    {...other}
                >
                    {icon}
                </IconButton>
            </Box>
        );

        if (href || to) {
            button = (
                <Box>
                    <IconButton
                        component={Link}
                        href={href}
                        ref={ref}
                        target={target}
                        to={to}
                        underline="none"
                        onClick={onClick}
                        {...other}
                        size="large"
                        sx={buttonSx}
                    >
                        {icon}
                    </IconButton>
                </Box>
            );
        }

        return <Tooltip title={!open ? tooltipText : ''}>{button}</Tooltip>;
    }
);
